import { render, staticRenderFns } from "./ArmsBaseArchiveLocation.vue?vue&type=template&id=84dac7aa&scoped=true&"
import script from "./ArmsBaseArchiveLocation.vue?vue&type=script&lang=js&"
export * from "./ArmsBaseArchiveLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dac7aa",
  null
  
)

export default component.exports